import { type SelectionRange } from '../../machine/state/types';
import { createEffect } from '../utils/create-effect';

export interface ApplyFillEffectDeps {
  resolveRangeToIds: (range: SelectionRange) => {
    entryIds: string[];
    fieldIds: string[];
  };
  onFillValues: (params: {
    fillEntryIds: string[];
    fillFieldIds: string[];
    sourceEntryIds: string[];
    sourceFieldIds: string[];
  }) => void;
  onSelectFilledValues: (
    filledValues: Array<{ entryId: string; fieldId: string }>
  ) => void;
}

export const createApplyFillEffect = createEffect(
  ({ resolveRangeToIds, onFillValues, onSelectFilledValues }: ApplyFillEffectDeps) => {
    return {
      deltaTypes: ['fillApplied'],

      onDelta(delta) {
        const source = resolveRangeToIds(delta.sourceRange);
        const fill = resolveRangeToIds(delta.fillRange);

        onFillValues({
          fillEntryIds: fill.entryIds,
          fillFieldIds: fill.fieldIds,
          sourceEntryIds: source.entryIds,
          sourceFieldIds: source.fieldIds,
        });

        const filledValues = fill.entryIds.flatMap((entryId) =>
          fill.fieldIds.map((fieldId) => ({ entryId, fieldId }))
        );

        requestAnimationFrame(() => {
          onSelectFilledValues(filledValues);
        });
      },
    };
  }
);
